import { TypedUseSelectorHook, useSelector } from 'react-redux';

export type DefaultReducersReduxState = {
    relayVariables: {
        variables: {
            showLoading?: boolean;
            userId?: string;
            itemId?: string;
            isClient: boolean;
            isMultiSku?: boolean;
            fetchAuction?: boolean;
            fetchUser?: boolean;
            isTrade?: boolean;
            isCondensedPdpRedesignVariant?: boolean;
            updateAuctionItem?: boolean;
            updatedUserCountryCode?: string;
            updateItemPricing?: boolean;
        };
    };
    header: {
        updateUserState?: boolean;
    };
};

export const useSbSelector: TypedUseSelectorHook<DefaultReducersReduxState> = useSelector;
